module.exports = __webpack_public_path__ + "static/media/pricing1.3a772364.png";